import { HeartFilled } from "@ant-design/icons";
import { Layout, Space } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const { Footer } = Layout;

export default function FooterBar() {
  const { t } = useTranslation();

  return (
    <Footer style={{ textAlign: "center", padding: "24px 50px" }}>
      <Space direction="vertical" size="small">
        <span>{t("footer.tagline")}</span>
        <Space split="|" size="middle" style={{ fontSize: "12px" }}>
          <span>
            © {new Date().getFullYear()} {t("footer.madeWith")}{" "}
            <HeartFilled style={{ color: "#ff4d4f" }} />
          </span>
          <Link to="/about">{t("footer.about")}</Link>
          <Link to="/legal">{t("footer.legal")}</Link>
        </Space>
      </Space>
    </Footer>
  );
}
